import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "passwordStrength"
})
export class PasswordStrengthPipe implements PipeTransform {
  transform(password: string): unknown {
    const passwordStrength = this.scorePassword(password);
    if (passwordStrength > 70) {
      return {
        style: {'bg-success': true},
        passwordStrength
      }
    } else if (passwordStrength > 30 && passwordStrength <= 70) {
      return {
        style: {'bg-warning': true},
        passwordStrength
      }
    } else {
      return {
        style: {'bg-danger': true},
        passwordStrength
      }
    }
  }

  scorePassword = pass => {
    let score = 0;
    if (!pass) return score;

    // award every unique letter until 5 repetitions
    let letters = {};
    for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }

    // bonus points for mixing it up
    let variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass)
    };

    let variationCount = 0;
    for (let check in variations) {
      variationCount += variations[check] ? 1 : 0;
    }
    score += (variationCount - 1) * 10;
    if (score > 100) {
      score = 100;
    }
    return score;
  };
}
